import React from 'react';
import { getParticularWeekDay, getFormattedDateFromDateObject } from '../../../../Utils/timeConvertorHelper';
import { SummaryCell, WorkoutOfTheDayContainer } from './style';
import { TruncatedText } from '../../../UI/Text';
import { timeFormats } from '../../../../Constants/timeFormats';

export const WorkoutOfTheDaySummary = ({
    weekSelected,
    onToggleModal,
    workoutsOfTheDay,
    cellWidth,
    columnDimensions,
}) => {
    return [...Array(7)].map((arr, index) => {
        const currentCellDate = getParticularWeekDay(weekSelected, index + 1);
        const formattedDate = getFormattedDateFromDateObject(currentCellDate, timeFormats.SERVER_DATE_TYPE);
        let isWorkoutPresent = false;
        let currentWorkout;
        2;
        workoutsOfTheDay.forEach(workout => {
            if (workout.date === formattedDate) {
                isWorkoutPresent = true;
                currentWorkout = workout;
            }
        });

        const width = columnDimensions.length > 0 ? columnDimensions[index].width : null;

        return (
            <SummaryCell key={index} width={`${width || cellWidth}px`}>
                <WorkoutOfTheDayContainer onClick={() => onToggleModal(0, formattedDate)}>
                    {isWorkoutPresent ? (
                        <TruncatedText fontSize={10} weight={100} opacity={0.75}>
                            💪 {currentWorkout.workout.title}
                        </TruncatedText>
                    ) : (
                        <TruncatedText fontSize={10} weight={100} opacity={0.75}>
                            + Add workout
                        </TruncatedText>
                    )}
                </WorkoutOfTheDayContainer>
            </SummaryCell>
        );
    });
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/WorkoutOfTheDaySummary.js